import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import React from "react";
import strings from "../../config/localization";
import DeleteButton from "../Buttons/DeleteButton";
import { Stack } from "@mui/material";
import { isObjectEmpty } from "../../pages/util";

export default function Line({
  data: props_data,
  metaData: props_metaData,
  index: props_index,
  onChange: props_onChange,
  onDelete: props_onDelete,
}) {
  console.log("Line props:", props_data, props_metaData);

  const [data, setData] = React.useState(props_data);
  React.useEffect(() => {
    console.log("Line, useEffect, props:data", props_data);
    setData({ ...props_data });
  }, [props_data]);

  if (!props_data || isObjectEmpty(props_data)) {
    return <></>;
  }

  const onValueChange = (id, value) => {
    console.log("onValueChange, value:", value);
    const updated = { ...data, [id]: value };
    console.log("onValueChange, updated:", updated);
    props_onChange(props_index, updated);
  };

  const getInputField = (field, data) => {
    console.log("getInputField, field:", field);
    console.log("getInputField, data:", data);
    return (
      <TextField
        style={{ width: field.width }}
        margin="none"
        value={data[field.id]}
        id={`${field.id}${props_index}`}
        name={field.id}
        onChange={(e) => {
          onValueChange(field.id, e.target.value);
        }}
      />
    );
  };

  const getAutocompleteField = (field, data) => {
    console.log("getAutocompleteField, field:", field);
    console.log("getAutocompleteField, data:", data);
    const fieldId = field.id;
    console.log("getAutocompleteField, fieldId:", fieldId);
    const value = data[fieldId];
    console.log("getAutocompleteField, value:", value);
    return (
      <Autocomplete
        id={`${field.id}${props_index}`}
        options={field.options.toSorted()}
        value={value}
        onChange={(e, value) => {
          onValueChange(field.id, value);
        }}
        renderInput={(params) => (
          <TextField {...params} margin="none" style={{ width: field.width }} />
        )}
      />
    );
  };

  return (
    <Stack direction="row">
      {props_metaData.map((field) => {
        if (field.type === "text") {
          return getInputField(field, data);
        } else if (field.type === "autocomplete") {
          return getAutocompleteField(field, data);
        }
        return <></>;
      })}
      <DeleteButton
        className="secondary"
        label={strings.remove}
        onClickHandler={() => {
          props_onDelete(props_index);
        }}
      />
    </Stack>
  );
}
